import { useQuery } from '@apollo/client';

import { graphQLIdGenerator } from 'helpers/graphql-utils';
import { GQL_GET_PROJECT_TAGS } from '../ProjectTags.graphql';
import { convertTagsDataToLegacyFormat } from '../helpers';

const useProjectTags = (projectDatabaseId) => {
  const projectNodeId = graphQLIdGenerator('Location', projectDatabaseId);

  const { loading, data, previousData } = useQuery(GQL_GET_PROJECT_TAGS, {
    fetchPolicy: 'cache-and-network',
    variables: { id: projectNodeId },
  });

  const tags = convertTagsDataToLegacyFormat(data ?? previousData);

  return {
    isLoadingTags: loading,
    tags,
  };
};

export default useProjectTags;
